import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from '@app/pages/error-pages/page-not-found.component';
import { AuthorizationByKeyGuard } from '@core/guards/authorization-by-key.guard';
import { AuthorizationTypes } from '@core/enums/authorization-types.enum';
import { AuthorizationResourceKey } from '@core/enums/authorization-resource-key.enum';
import { AuthorizationOperations } from '@core/enums/authorization-operations.enum';
import { AuthGuard } from '@core/guards/auth.guard';
import { CalendarSectionModule } from '@modules/calendar/calendar-section.module';
import { CommissioningSectionModule } from '@modules/commissioning/commissioning-section.module';
import { DutySectionModule } from '@modules/duty/duty-section.module';
import { ScadaSectionModule } from '@modules/scada/scada-section.module';
import { ConfigurationSectionModule } from '@modules/configuration/configuration-section.module';
import { AuthenticationSectionModule } from '@modules/authentication/authentication-section.module';
import { HomeModule } from '@modules/home/home.module';

const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/authentication/authentication-section.module').then(
        (m: { AuthenticationSectionModule: AuthenticationSectionModule }) =>
          m.AuthenticationSectionModule
      )
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m: { HomeModule: HomeModule }) => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'config',
    loadChildren: () =>
      import('./modules/configuration/configuration-section.module').then(
        (m: { ConfigurationSectionModule: ConfigurationSectionModule }) =>
          m.ConfigurationSectionModule
      ),
    canActivateChild: [AuthGuard, AuthorizationByKeyGuard],
    data: {
      type: AuthorizationTypes.STARTPAGE_ITEM,
      resourceId: AuthorizationResourceKey.CONFIGURATION,
      operation: AuthorizationOperations.VIEW
    }
  },
  // {
  //   path: 'application',
  //   loadChildren: () =>
  //     import('./modules/scada/scada-section.module').then(
  //       (m: { ScadaSectionModule: ScadaSectionModule }) => m.ScadaSectionModule
  //     ),
  //   canActivateChild: [AuthGuard]
  // },
  {
    path: 'duty',
    loadChildren: () =>
      import('./modules/duty/duty-section.module').then(
        (m: { DutySectionModule: DutySectionModule }) => m.DutySectionModule
      ),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./modules/calendar/calendar-section.module').then(
        (m: { CalendarSectionModule: CalendarSectionModule }) => m.CalendarSectionModule
      ),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'commissioning',
    loadChildren: () =>
      import('./modules/commissioning/commissioning-section.module').then(
        (m: { CommissioningSectionModule: CommissioningSectionModule }) =>
          m.CommissioningSectionModule
      ),
    canActivateChild: [AuthGuard]
  },
  // {
  //   path: 'user-profile',
  //   loadChildren: () =>
  //     import('./modules/user-profile/user-profile.module').then((m: { UserProfileModule: UserProfileModule }) => m.UserProfileModule),
  // },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      paramsInheritanceStrategy: 'always'
    })
  ],
  declarations: [],
  exports: [RouterModule],
  providers: []
})
export class AppRouting {}
